module.exports = __webpack_public_path__ + "img/max-office-building-configure.e3e3e13d.svg";